export enum UserPlanStatus {
    None = "none",
    PaymentPending = "pending_payment",
    Regular = "regular",
    Inactive = "inactive",
    Irregular = "irregular",
    Expired = "expired",
}
